import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useMemo } from "react";
import "./desktopSignoutRoute.css";

function DesktopSignoutRoute() {
  const { logout, isAuthenticated, isLoading } = useAuth0();
  const done = useMemo(
    () => new URLSearchParams(window.location.search).get("done") === "1",
    [],
  );

  useEffect(() => {
    if (done && !isLoading && isAuthenticated) {
      localStorage.removeItem("user_email");
      logout({ openUrl: false });
    }
  }, [done, isLoading, isAuthenticated, logout]);

  const handleBrowserSignOut = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin + "/desktop-signout?done=1",
      },
    });
  };

  const body = done ? (
    <>
      <h1 className="ds-title">You've been signed out.</h1>
      <p className="ds-body">
        You're signed out of OverWatch on this device and in this browser. You
        can safely close this tab.
      </p>
    </>
  ) : (
    <>
      <h1 className="ds-title">Signed out of the desktop app.</h1>
      <p className="ds-body">
        If you share this computer, also sign out of OverWatch in this browser
        so the next person starts with their own account.
      </p>
      <div className="ds-actions">
        <button
          type="button"
          className="ds-btn ds-btn--primary"
          onClick={handleBrowserSignOut}
        >
          Sign Out From Browser
        </button>
      </div>
    </>
  );

  return (
    <div className="ds-screen">
      <div className="ds-card">
        <img
          src="/svgs/4Sight_Labs_Logo_White.svg"
          alt="OverWatch"
          className="ds-logo"
        />
        <p className="ds-eyebrow">OverWatch</p>
        {body}
      </div>
    </div>
  );
}

export default DesktopSignoutRoute;
